module.exports = __webpack_public_path__ + "media/application/images/svgs/search-dark-2d118b04bf2451bfd5a02a1a1c4925f0.svg";